import ClientCatalogModel from 'Models/ClientCatalogModel';
import searchStore from 'Root/store/modules/search';
import GameModel from 'Models/GameModel';
import { TAGS_AS_PRODUCTS_LIST } from 'Root/helpers/env';

export default function games(store) {
  const gameRoutes = [
    {
      path: '/:namespace-boost',
      name: 'games__namespace',
      component: () => import(
        /* webpackChunkName: 'game-core' */ '../../pages/game/GameCore.vue'
      ),
      beforeEnter(to, from, next) {
        if (!store.hasModule('search')) {
          const options = {};
          if (store.state.search) {
            options.preserveState = true;
          }

          store.registerModule('search', searchStore, options);
        }

        next();
      },

      children: [
        {
          name: 'game__product-detail',
          path: 'products/:id/:offerId?',
          meta: {
            chunksToPrefetch: ['game-service', 'game-main'],
            shouldUseBg: ClientCatalogModel.BG.SKIP,
            isCenteredPage: true,
            mayVaryByRegion: true,
            isPreviewAvailable: true,
          },
          component: () => import(
            /* webpackChunkName: 'game-offer' */ '../../pages/game/gameOffer/GameOffer.vue'
          ),
        },
        {
          name: 'game__root',
          path: '/:namespace-boost',
          meta: {
            chunksToPrefetch: ['game-offer', 'game-service'],
            shouldUseBg: ClientCatalogModel.BG.DEFAULT,
            isCenteredPage: true,
          },
          component: () => import(
            /* webpackChunkName: 'game-main' */ '../../pages/game/gameMain/GameMain.vue'
          ),
        },
        {
          name: 'game__service',
          path: ':categories*',
          meta: {
            chunksToPrefetch: ['game-offer', 'game-main'],
            shouldUseBg: ClientCatalogModel.BG.DEFAULT,
            isCenteredPage: true,
          },
          component: () => import(
            /* webpackChunkName: 'game-service' */ '../../pages/game/gameService/GameService.vue'
          ),
        },
      ],
    },
  ];

  if (TAGS_AS_PRODUCTS_LIST) {
    TAGS_AS_PRODUCTS_LIST.forEach((tagInfo) => {
      gameRoutes.unshift({
        path: `/${GameModel.ID_TO_DATA[tagInfo.gameId].routeNamespace}-boost/${tagInfo.tagUrl}`,
        component: () => import(
          /* webpackChunkName: 'game-core' */ '../../pages/game/GameCore.vue'
        ),

        children: [{
          path: ':offerId?',
          name: `game__tag-as-product--${tagInfo.gameId}-${tagInfo.tagUrl}`,
          component: () => import(
            /* webpackChunkName: 'game-offer' */ '../../pages/game/gameOffer/GameOffer.vue'
          ),
          meta: {
            chunksToPrefetch: ['game-service', 'game-main'],
            shouldUseBg: ClientCatalogModel.BG.SKIP,
            isCenteredPage: true,
            mayVaryByRegion: true,
            isPreviewAvailable: true,
            tagAsOfferInfo: tagInfo,
          },
        }],
      });
    });
  }

  return gameRoutes;
}
